import { render, staticRenderFns } from "./FavouriteNavItem.vue?vue&type=template&id=439e902f"
import script from "./FavouriteNavItem.vue?vue&type=script&lang=js"
export * from "./FavouriteNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports